// LOCATION: admin-portal/src/App.js

import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { auth, db } from './firebase'; 
import { doc, getDoc } from 'firebase/firestore';

// Component Imports
import Sidebar from './components/Sidebar';
import Login from './pages/Login'; 
import LandingPage from './pages/LandingPage';
import UserManagement from './pages/UserManagement';
import Events from './pages/Events';
import AccessManagement from './pages/AccessManagement';
import Subscribers from './pages/Subscribers';
import StaffManagement from './pages/StaffManagement';
import NotificationManager from './pages/Notifications';
import JourneyLogs from './pages/JourneyLogs'; // ✅ NEW IMPORT

import './App.css'; 

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [permissions, setPermissions] = useState({});

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser) {
        try {
          const docRef = doc(db, 'admin_access', currentUser.email);
          const docSnap = await getDoc(docRef);
          
          if (docSnap.exists()) {
            setUser(currentUser);
            setPermissions(docSnap.data().permissions || {});
          } else {
            await auth.signOut();
            setUser(null);
          }
        } catch (error) {
          console.error("Permission check failed:", error);
          setUser(null);
        }
      } else {
        setUser(null);
        setPermissions({});
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading) return <div className="loading-screen">Loading Ccuring...</div>;

  return (
    <Router>
      <div className="app-container">
        {user && <Sidebar permissions={permissions} />}

        <div className={user ? "main-content" : "login-content"}>
          <Routes>
            <Route path="/" element={user ? <Navigate to="/users" /> : <LandingPage />} />
            <Route path="/login" element={!user ? <Login /> : <Navigate to="/users" />} />

            {/* Protected Admin Routes */}
            <Route 
              path="/users" 
              element={user && (permissions.user_management || permissions.super_admin) ? <UserManagement /> : <Navigate to="/login" />} 
            />

            <Route 
              path="/events" 
              element={user && (permissions.events || permissions.super_admin) ? <Events /> : <Navigate to="/login" />} 
            />

            {/* ✅ NEW ROUTE: Journey Logs & Billing */}
            <Route 
              path="/journey-logs" 
              element={user && (permissions.events || permissions.super_admin) ? <JourneyLogs /> : <Navigate to="/login" />} 
            />

            <Route 
              path="/subscribers" 
              element={user && (permissions.subscribers || permissions.super_admin) ? <Subscribers /> : <Navigate to="/login" />} 
            />

            <Route 
              path="/staff" 
              element={user && (permissions.super_admin) ? <StaffManagement /> : <Navigate to="/login" />} 
            />

            <Route 
              path="/access" 
              element={user && (permissions.admin_access || permissions.super_admin) ? <AccessManagement /> : <Navigate to="/login" />} 
            />

            <Route 
              path="/notifications" 
              element={user && (permissions.notifications || permissions.super_admin) ? <NotificationManager /> : <Navigate to="/login" />} 
            />

            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;